import { Loading } from '@bumble/app/components/Loading';
import { getChartTime, getTooltipLabel } from '@bumble/app/utils/get-date';
import { PureComponent } from 'react';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const chartColors = ['#1F2848', '#1E8497', '#B3A689', '#BC9777', '#D3782B'];

interface RxDataItem {
  '@timestamp': string;
  ep_id?: string;
  appservice_id?: string;
  'rx.pkts': number;
  'rx.bytes': number;
  'tx.pkts': number;
  'tx.bytes': number;
}
interface RxData {
  [epIdOrAppServiceId: string]: RxDataItem[];
}
interface RxTxLineChartProps {
  data: RxData[];
  selector: string;
  loading?: boolean;
  hours?: number;
}
export default class RxTxLineChart extends PureComponent<RxTxLineChartProps> {
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    loading: false,
  };

  render() {
    const { data, selector, loading, hours = 0 } = this.props;
    const series = data.map((d) => {
      const id = Object.keys(d)[0] as string;
      return {
        name: id,
        data: d[id].map((obj: RxDataItem) => {
          return { time: Date.parse(obj['@timestamp']), value: obj[selector as keyof RxDataItem] };
        }),
      };
    });

    if (loading) return <Loading height={280} />;
    return (
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          width={500}
          height={300}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="time"
            type="category"
            allowDuplicatedCategory={false}
            tickFormatter={(x) => getChartTime(x, hours)}
          />
          <YAxis dataKey="value" />
          <Tooltip labelFormatter={(label) => getTooltipLabel(label)} />
          <Legend />
          {series.map((s, i) => (
            <Line
              stroke={chartColors[i % chartColors.length]}
              activeDot={{ r: 6 }}
              dot={false}
              dataKey="value"
              data={s.data}
              name={s.name}
              key={s.name}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    );
  }
}
